import type { FillTitleProperties, FormElement } from '../../model/form.types';
import type { StaticDefinition } from '../../model/types';
import { textStyle } from './shared';

type FillTitleElement = FormElement & { properties: FillTitleProperties };

export const fillTitleDefinition: StaticDefinition<FillTitleElement> = {
  kind: 'static',
  type: 'FILL_TITLE',
  compile: (element, context) => {
    const titleType = element.properties.fillTitleType;
    return {
      kind: 'static',
      id: element.id,
      type: 'FILL_TITLE',
      text: titleType ? (context.titles.fillTitles?.[titleType] ?? '') : '',
      style: textStyle(element),
      visible: true,
      element,
    };
  },
};
